import React, { useRef, useState } from 'react';
import DialogHeader from '../DialogHeader';
import {
  Button,
  Dialog,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { DESTROY_BACKDROP, OPEN_BACKDROP } from '../../../../containers/actions/types';
import StyledDialog from '../../../../../common/models/Dialog';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '40vw',
    [theme.breakpoints.down('xs')]: {
      width: '80vw',
    },
  },
  textField: {
    '& input.MuiInputBase-input.MuiOutlinedInput-input': {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-multiline.MuiOutlinedInput-multiline':
      {
        paddingTop: '10px',
        paddingBottom: '10px',
      },
  },
}));

const AddWarehouse = (props) => {
  const classes = useStyles();
  const { handleClose } = props;
  const dispatch = useDispatch();
  const errorRef = useRef();

  const [mainError, setmainError] = useState('');
  const [fieldError, setFieldError] = useState(null)

  const [warehouseDetails, setWarehouseDetails] = useState({
    warehouseName: '',
    warehouseMainAddress: '',
    warehouseCode: '',
    pickupAddress: '',
    deliveryAddress: '',
  });

  const [addedSuccessfull, setAddedSuccessfull] = useState(false);

  const handleOnChange = (event) => {
    setmainError('');
    setFieldError(null)
    setWarehouseDetails({
      ...warehouseDetails,
      [event.target.name]: event.target.value,
    });
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    // Only trim leading and trailing spaces for string values
    if (typeof value === "string" && value.trim() !== value) {
      const trimmedValue = value.trim();
      setWarehouseDetails({
        ...warehouseDetails,
        [name]: trimmedValue,
      });
    }
  };

  const validate = () => {
    let validated = true;
    let errors = null;
    if (!warehouseDetails.warehouseName || warehouseDetails.warehouseName === '') {
      errors = {
        ...errors,
        warehouseName: 'Enter warehouse name',
      }
      validated = false;
    }

    if (!warehouseDetails.warehouseMainAddress || warehouseDetails.warehouseMainAddress === '') {
      errors = {
        ...errors,
        warehouseMainAddress: 'Enter warehouse address',
      }
      validated = false;
    }

    if (!validated) {
      setFieldError(errors)
    }

    return validated;
  }

  const handleSaveWarehouse = () => {
    const validated = validate();
    
    if (validated) {
      dispatch({
        type: OPEN_BACKDROP,
        backdropText: 'Please wait...',
      });
      setTimeout(() => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // setmainError('Something went wrong. Please try again.')
        // errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setAddedSuccessfull(true)
      },3000)
    } else {
        setmainError('Enter the mandatory fields')
        errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    
  }

  const handleCloseSave = () => {
    setAddedSuccessfull(false);
    handleClose()
  }

  return (
    <React.Fragment>
    <div className={classes.list}>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{ padding: '1rem' }}
      >
        <Grid ref={errorRef} item xs={12} sm={12} md={12}>
          <DialogHeader header={'Add new warehouse'} />
        </Grid>
          <Grid container spacing={2}>
            {mainError &&
            <div
                        style={{
                          display: "flex",
                          justifyContent: "center", // Horizontally center the CircularProgress
                          alignItems: "center", // Vertically center the CircularProgress
                          height: "50px", // Optional: Set a height to vertically center the loader
                          border: "2px solid #FF0000",
                          backgroundColor: "#FFF0F0",
                          width: "100%",
                        }}
                      >
                        <Typography style={{ textAlign: "center" }}>
                          {mainError}
                        </Typography>
                      </div>
            }
            
          <Grid item xs={12}>
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontSize: '1.5rem',
                fontWeight: '500',
                paddingBottom: '10px',
                justifySelf: 'flex-start',
              }}
            >
              Warehouse details
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' style={{ fontWeight: '500' }}>
              Warehouse Name <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              variant='outlined'
              className={classes.textField}
              placeholder='Enter warehouse name'
              name='warehouseName'
              value={warehouseDetails.warehouseName}
                onChange={(e) => handleOnChange(e)}
                onBlur={handleBlur}
                error={fieldError?.warehouseName}
                helperText={
                  fieldError?.warehouseName ? fieldError?.warehouseName : ""
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                Warehouse ID
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                className={classes.textField}
                placeholder="Enter warehouse ID"
                name="warehouseCode"
                value={warehouseDetails.warehouseCode}
                onChange={(e) => handleOnChange(e)}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                Main Address <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                className={classes.textField}
                placeholder="Enter main address"
                name="warehouseMainAddress"
                value={warehouseDetails.warehouseMainAddress}
                onChange={(e) => handleOnChange(e)}
                onBlur={handleBlur}
                error={fieldError?.warehouseMainAddress}
                helperText={
                  fieldError?.warehouseMainAddress
                    ? fieldError?.warehouseMainAddress
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                Pickup Address
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                className={classes.textField}
                placeholder="Enter pickup address"
                name="pickupAddress"
                value={warehouseDetails.pickupAddress}
                onChange={(e) => handleOnChange(e)}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                Delivery Address
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                className={classes.textField}
                placeholder="Enter delivery address"
                name="deliveryAddress"
                value={warehouseDetails.deliveryAddress}
                onChange={(e) => handleOnChange(e)}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Button
                variant="outlined"
                style={{ textTransform: "none" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                style={{ textTransform: "none" }}
                onClick={() => handleSaveWarehouse()}
              >
                Save Changes
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Dialog open={addedSuccessfull} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseSave}
          title={"Warehouse added successfully"}
        />
      </Dialog>
    </React.Fragment>
  );
};

export default AddWarehouse;
